import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../../utils/general";

export const generalApiSlice = createApi({
  reducerPath: "generalApi",
  tagTypes: ["General"],
  baseQuery: customBaseQuery,

  endpoints: (builder) => ({
    tokenPrices: builder.query({
      query: () => ({
        url: "/tokens/prices",
      }),
      providesTags: ["General"],
    }),
  }),
});

export const { useTokenPricesQuery } = generalApiSlice;
